var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-admin"
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-stretch shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v(_vm._s(_vm.$t('admin.create.addUser')))]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": _vm.$t('admin.create.name'),
      "placeholder": _vm.$t('admin.create.namePlaceholder'),
      "required": ""
    },
    model: {
      value: _vm.payloads.name,
      callback: function callback($$v) {
        _vm.$set(_vm.payloads, "name", $$v);
      },
      expression: "payloads.name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": _vm.$t('admin.create.email'),
      "placeholder": _vm.$t('admin.create.emailPlaceholder'),
      "required": ""
    },
    model: {
      value: _vm.payloads.email,
      callback: function callback($$v) {
        _vm.$set(_vm.payloads, "email", $$v);
      },
      expression: "payloads.email"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "label": _vm.$t('admin.create.phone'),
      "placeholder": _vm.$t('admin.create.phonePlaceholder'),
      "required": ""
    },
    model: {
      value: _vm.payloads.phone_number,
      callback: function callback($$v) {
        _vm.$set(_vm.payloads, "phone_number", $$v);
      },
      expression: "payloads.phone_number"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('admin.create.passwordPlaceholder'),
      "label": _vm.$t('admin.create.passwordPlaceholder'),
      "required": ""
    },
    model: {
      value: _vm.payloads.password,
      callback: function callback($$v) {
        _vm.$set(_vm.payloads, "password", $$v);
      },
      expression: "payloads.password"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 mdmax:w-full mdmax:flex-auto p-6"
  })]), _c('div', {
    staticClass: "w-full bg-white p-6"
  }, [_c('div', {
    staticClass: "flex gap-6 justify-end"
  }, [_c('div', {}, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('admin.create.save'),
      "type": "primary",
      "disabled": _vm.isDisabled
    },
    on: {
      "action": function action($event) {
        return _vm.save();
      }
    }
  })], 1)])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }